<div class="flex flex-row items-center justify-center">

    <div *ngIf="status === StatusType.PENDING">
        <div class="flex items-center justify-center p-1 rounded-base  border-gray-400 " pTooltip="Pending"
            tooltipPosition="bottom" [tooltipOptions]="{appendTo: 'body'}">
            <i class="pi pi-clock text-gray-600 icon-xs"></i>
        </div>
    </div>

    <div *ngIf="status === StatusType.IN_PROGRESS">
        <div class="flex items-center justify-center p-1 rounded-base" pTooltip="In Progress" tooltipPosition="bottom"
            [tooltipOptions]="{appendTo: 'body'}">
            <i class="pi pi-spinner animate-spin text-gray-600 icon-xs"></i>
        </div>
    </div>

    <div *ngIf="status === StatusType.COMPLETED">
        <div class="flex items-center justify-center p-1 rounded-base bg-green-500" pTooltip="Completed"
            tooltipPosition="bottom" [tooltipOptions]="{appendTo: 'body'}">
            <i class="pi pi-check text-white icon-xs"></i>
        </div>
    </div>

    <div *ngIf="status === StatusType.FAILED">
        <div class="flex items-center justify-center p-1 rounded-base bg-red-500" pTooltip="Failed"
            tooltipPosition="bottom" [tooltipOptions]="{appendTo: 'body'}">
            <i class="pi pi-times text-white icon-xs"></i>
        </div>
    </div>
</div>
